import styled from '@emotion/styled/macro';
import { forPhoneOnly, Spinner, Variables } from '@enter/core';
import { PageLayout } from 'components';

export const Wrapper = styled(PageLayout)`
    background-color: ${Variables.Colors.white};
    padding: 0;
    height: calc(100vh - ${Variables.topnavSize});

    ${forPhoneOnly(`
        height: calc(100vh - ${Variables.topnavSize});
    `)};
`;

export const Loader = styled(Spinner)`
    flex-grow: 0;
    margin-top: 40%;
`;

export const Message = styled.div`
    justify-self: start;
    padding: 48px;
`;

export const Embedded = styled.div`
    display: flex;
    margin: 0;
    flex-grow: 1;

    & > iframe {
        border: none;
    }
`;
